var map = {
	"./star0-10.svg": "1721",
	"./star1-10.svg": "9998",
	"./star10-10.svg": "26bf",
	"./star2-10.svg": "4f21",
	"./star3-10.svg": "40a7",
	"./star4-10.svg": "f667",
	"./star5-10.svg": "24a2",
	"./star6-10.svg": "86cd",
	"./star7-10.svg": "5e42",
	"./star8-10.svg": "25d1",
	"./star9-10.svg": "2cec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7538";